import { p as ce } from "../vendor-dcffe3e4.js";
import { watch as x, nextTick as U, getCurrentScope as fe, onScopeDispose as de, unref as G, toRef as ve, readonly as $, customRef as me, ref as b, onMounted as Y, getCurrentInstance as X, isRef as pe, shallowRef as L, computed as _, watchEffect as he, defineComponent as B, toRaw as we } from "vue";
function I(e) {
  return fe() ? (de(e), !0) : !1;
}
function ye(e, t) {
  if (typeof Symbol < "u") {
    const n = { ...e };
    return Object.defineProperty(n, Symbol.iterator, {
      enumerable: !1,
      value() {
        let o = 0;
        return {
          next: () => ({
            value: t[o++],
            done: o > t.length
          })
        };
      }
    }), n;
  } else
    return Object.assign([...t], e);
}
function g(e) {
  return typeof e == "function" ? e() : G(e);
}
const F = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const K = (e) => e != null, ge = Object.prototype.toString, be = (e) => ge.call(e) === "[object Object]", E = () => {
}, V = /* @__PURE__ */ Te();
function Te() {
  var e, t;
  return F && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Oe(e, t) {
  function n(...o) {
    return new Promise((r, a) => {
      Promise.resolve(e(() => t.apply(this, o), { fn: t, thisArg: this, args: o })).then(r).catch(a);
    });
  }
  return n;
}
const Ae = (e) => e();
function xe(e, t = {}) {
  let n, o, r = E;
  const a = (u) => {
    clearTimeout(u), r(), r = E;
  };
  return (u) => {
    const c = g(e), f = g(t.maxWait);
    return n && a(n), c <= 0 || f !== void 0 && f <= 0 ? (o && (a(o), o = null), Promise.resolve(u())) : new Promise((l, s) => {
      r = t.rejectOnCancel ? s : l, f && !o && (o = setTimeout(() => {
        n && a(n), o = null, l(u());
      }, f)), n = setTimeout(() => {
        o && a(o), o = null, l(u());
      }, c);
    });
  };
}
function _e(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}
const Se = /-(\w)/g, Ie = _e((e) => e.replace(Se, (t, n) => n ? n.toUpperCase() : ""));
function Ee(e, t = !1, n = "Timeout") {
  return new Promise((o, r) => {
    setTimeout(t ? () => r(n) : o, e);
  });
}
function Z(e) {
  return e;
}
function De(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const o = t;
    t = void 0, o && await o;
  }, n;
}
function ke(e) {
  return e || X();
}
function Fe(...e) {
  if (e.length !== 1)
    return ve(...e);
  const t = e[0];
  return typeof t == "function" ? $(me(() => ({ get: t, set: E }))) : b(t);
}
function Ce(e, t, n = {}) {
  const {
    eventFilter: o = Ae,
    ...r
  } = n;
  return x(
    e,
    Oe(
      o,
      t
    ),
    r
  );
}
function N(e, t = !0, n) {
  ke() ? Y(e, n) : t ? e() : U(e);
}
function Re(e, t = 1e3, n = {}) {
  const {
    immediate: o = !0,
    immediateCallback: r = !1
  } = n;
  let a = null;
  const i = b(!1);
  function u() {
    a && (clearInterval(a), a = null);
  }
  function c() {
    i.value = !1, u();
  }
  function f() {
    const l = g(t);
    l <= 0 || (i.value = !0, r && e(), u(), i.value && (a = setInterval(e, l)));
  }
  if (o && F && f(), pe(t) || typeof t == "function") {
    const l = x(t, () => {
      i.value && F && f();
    });
    I(l);
  }
  return I(c), {
    isActive: i,
    pause: c,
    resume: f
  };
}
function Le(e, t, n = {}) {
  const {
    immediate: o = !0
  } = n, r = b(!1);
  let a = null;
  function i() {
    a && (clearTimeout(a), a = null);
  }
  function u() {
    r.value = !1, i();
  }
  function c(...f) {
    i(), r.value = !0, a = setTimeout(() => {
      r.value = !1, a = null, e(...f);
    }, g(t));
  }
  return o && (r.value = !0, F && c()), I(u), {
    isPending: $(r),
    start: c,
    stop: u
  };
}
function nt(e, t, n = {}) {
  const {
    debounce: o = 0,
    maxWait: r = void 0,
    ...a
  } = n;
  return Ce(
    e,
    t,
    {
      ...a,
      eventFilter: xe(o, { maxWait: r })
    }
  );
}
function ot(e, t, n) {
  const o = x(e, (...r) => (U(() => o()), t(...r)), n);
  return o;
}
function rt(e = {}) {
  const {
    inheritAttrs: t = !0
  } = e, n = L(), o = /* @__PURE__ */ B({
    setup(a, { slots: i }) {
      return () => {
        n.value = i.default;
      };
    }
  }), r = /* @__PURE__ */ B({
    inheritAttrs: t,
    setup(a, { attrs: i, slots: u }) {
      return () => {
        var c;
        if (!n.value && ce.env.NODE_ENV !== "production")
          throw new Error("[VueUse] Failed to find the definition of reusable template");
        const f = (c = n.value) == null ? void 0 : c.call(n, { ...We(i), $slots: u });
        return t && (f == null ? void 0 : f.length) === 1 ? f[0] : f;
      };
    }
  });
  return ye(
    { define: o, reuse: r },
    [o, r]
  );
}
function We(e) {
  const t = {};
  for (const n in e)
    t[Ie(n)] = e[n];
  return t;
}
const D = F ? window : void 0, J = F ? window.navigator : void 0;
function O(e) {
  var t;
  const n = g(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function A(...e) {
  let t, n, o, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, r] = e, t = D) : [t, n, o, r] = e, !t)
    return E;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const a = [], i = () => {
    a.forEach((l) => l()), a.length = 0;
  }, u = (l, s, v, d) => (l.addEventListener(s, v, d), () => l.removeEventListener(s, v, d)), c = x(
    () => [O(t), g(r)],
    ([l, s]) => {
      if (i(), !l)
        return;
      const v = be(s) ? { ...s } : s;
      a.push(
        ...n.flatMap((d) => o.map((p) => u(l, d, p, v)))
      );
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    c(), i();
  };
  return I(f), f;
}
let H = !1;
function at(e, t, n = {}) {
  const { window: o = D, ignore: r = [], capture: a = !0, detectIframe: i = !1 } = n;
  if (!o)
    return E;
  V && !H && (H = !0, Array.from(o.document.body.children).forEach((d) => d.addEventListener("click", E)), o.document.documentElement.addEventListener("click", E));
  let u = !0;
  const c = (d) => g(r).some((p) => {
    if (typeof p == "string")
      return Array.from(o.document.querySelectorAll(p)).some((m) => m === d.target || d.composedPath().includes(m));
    {
      const m = O(p);
      return m && (d.target === m || d.composedPath().includes(m));
    }
  }), f = (d) => {
    const p = O(e);
    if (!(!p || p === d.target || d.composedPath().includes(p))) {
      if (d.detail === 0 && (u = !c(d)), !u) {
        u = !0;
        return;
      }
      t(d);
    }
  };
  let l = !1;
  const s = [
    A(o, "click", (d) => {
      l || (l = !0, setTimeout(() => {
        l = !1;
      }, 0), f(d));
    }, { passive: !0, capture: a }),
    A(o, "pointerdown", (d) => {
      const p = O(e);
      u = !c(d) && !!(p && !d.composedPath().includes(p));
    }, { passive: !0 }),
    i && A(o, "blur", (d) => {
      setTimeout(() => {
        var p;
        const m = O(e);
        ((p = o.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(m != null && m.contains(o.document.activeElement)) && t(d);
      }, 0);
    })
  ].filter(Boolean);
  return () => s.forEach((d) => d());
}
function Pe(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function ut(...e) {
  let t, n, o = {};
  e.length === 3 ? (t = e[0], n = e[1], o = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], o = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: r = D,
    eventName: a = "keydown",
    passive: i = !1,
    dedupe: u = !1
  } = o, c = Pe(t);
  return A(r, a, (l) => {
    l.repeat && g(u) || c(l) && n(l);
  }, i);
}
function Me() {
  const e = b(!1), t = X();
  return t && Y(() => {
    e.value = !0;
  }, t), e;
}
function R(e) {
  const t = Me();
  return _(() => (t.value, !!e()));
}
function Ve(e, t, n = {}) {
  const { window: o = D, ...r } = n;
  let a;
  const i = R(() => o && "MutationObserver" in o), u = () => {
    a && (a.disconnect(), a = void 0);
  }, c = _(() => {
    const v = g(e), d = (Array.isArray(v) ? v : [v]).map(O).filter(K);
    return new Set(d);
  }), f = x(
    () => c.value,
    (v) => {
      u(), i.value && v.size && (a = new MutationObserver(t), v.forEach((d) => a.observe(d, r)));
    },
    { immediate: !0, flush: "post" }
  ), l = () => a == null ? void 0 : a.takeRecords(), s = () => {
    f(), u();
  };
  return I(s), {
    isSupported: i,
    stop: s,
    takeRecords: l
  };
}
function $e(e, t = {}) {
  const {
    immediate: n = !0,
    fpsLimit: o = void 0,
    window: r = D
  } = t, a = b(!1), i = o ? 1e3 / o : null;
  let u = 0, c = null;
  function f(v) {
    if (!a.value || !r)
      return;
    u || (u = v);
    const d = v - u;
    if (i && d < i) {
      c = r.requestAnimationFrame(f);
      return;
    }
    u = v, e({ delta: d, timestamp: v }), c = r.requestAnimationFrame(f);
  }
  function l() {
    !a.value && r && (a.value = !0, u = 0, c = r.requestAnimationFrame(f));
  }
  function s() {
    a.value = !1, c != null && r && (r.cancelAnimationFrame(c), c = null);
  }
  return n && l(), I(s), {
    isActive: $(a),
    pause: s,
    resume: l
  };
}
function Ne(e, t = {}) {
  const { window: n = D } = t, o = R(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let r;
  const a = b(!1), i = (f) => {
    a.value = f.matches;
  }, u = () => {
    r && ("removeEventListener" in r ? r.removeEventListener("change", i) : r.removeListener(i));
  }, c = he(() => {
    o.value && (u(), r = n.matchMedia(g(e)), "addEventListener" in r ? r.addEventListener("change", i) : r.addListener(i), a.value = r.matches);
  });
  return I(() => {
    c(), u(), r = void 0;
  }), a;
}
function Q(e, t = {}) {
  const {
    controls: n = !1,
    navigator: o = J
  } = t, r = R(() => o && "permissions" in o), a = L(), i = typeof e == "string" ? { name: e } : e, u = L(), c = () => {
    var l, s;
    u.value = (s = (l = a.value) == null ? void 0 : l.state) != null ? s : "prompt";
  };
  A(a, "change", c);
  const f = De(async () => {
    if (r.value) {
      if (!a.value)
        try {
          a.value = await o.permissions.query(i);
        } catch {
          a.value = void 0;
        } finally {
          c();
        }
      if (n)
        return we(a.value);
    }
  });
  return f(), n ? {
    state: u,
    isSupported: r,
    query: f
  } : u;
}
function it(e = {}) {
  const {
    navigator: t = J,
    read: n = !1,
    source: o,
    copiedDuring: r = 1500,
    legacy: a = !1
  } = e, i = R(() => t && "clipboard" in t), u = Q("clipboard-read"), c = Q("clipboard-write"), f = _(() => i.value || a), l = b(""), s = b(!1), v = Le(() => s.value = !1, r);
  function d() {
    i.value && y(u.value) ? t.clipboard.readText().then((w) => {
      l.value = w;
    }) : l.value = h();
  }
  f.value && n && A(["copy", "cut"], d);
  async function p(w = g(o)) {
    f.value && w != null && (i.value && y(c.value) ? await t.clipboard.writeText(w) : m(w), l.value = w, s.value = !0, v.start());
  }
  function m(w) {
    const T = document.createElement("textarea");
    T.value = w ?? "", T.style.position = "absolute", T.style.opacity = "0", document.body.appendChild(T), T.select(), document.execCommand("copy"), T.remove();
  }
  function h() {
    var w, T, S;
    return (S = (T = (w = document == null ? void 0 : document.getSelection) == null ? void 0 : w.call(document)) == null ? void 0 : T.toString()) != null ? S : "";
  }
  function y(w) {
    return w === "granted" || w === "prompt";
  }
  return {
    isSupported: f,
    text: l,
    copied: s,
    copy: p
  };
}
function st(e, t = {}) {
  var n, o;
  const r = b(!1), a = L(null);
  let i = 0, u = !0;
  if (F) {
    const c = typeof t == "function" ? { onDrop: t } : t, f = (n = c.multiple) != null ? n : !0, l = (o = c.preventDefaultForUnhandled) != null ? o : !1, s = (m) => {
      var h, y;
      const w = Array.from((y = (h = m.dataTransfer) == null ? void 0 : h.files) != null ? y : []);
      return w.length === 0 ? null : f ? w : [w[0]];
    }, v = (m) => {
      if (c.dataTypes) {
        const h = G(c.dataTypes);
        return typeof h == "function" ? h(m) : h ? h.some((y) => m.includes(y)) : !0;
      }
      return !0;
    }, d = (m) => {
      var h, y;
      const w = Array.from((y = (h = m.dataTransfer) == null ? void 0 : h.items) != null ? y : []), T = w.map((k) => k.type), S = v(T), C = f || w.length <= 1;
      return S && C;
    }, p = (m, h) => {
      var y, w, T, S;
      if (u = d(m), !u) {
        l && m.preventDefault(), m.dataTransfer && (m.dataTransfer.dropEffect = "none");
        return;
      }
      m.preventDefault(), m.dataTransfer && (m.dataTransfer.dropEffect = "copy");
      const C = s(m);
      switch (h) {
        case "enter":
          i += 1, r.value = !0, (y = c.onEnter) == null || y.call(c, null, m);
          break;
        case "over":
          (w = c.onOver) == null || w.call(c, null, m);
          break;
        case "leave":
          i -= 1, i === 0 && (r.value = !1), (T = c.onLeave) == null || T.call(c, null, m);
          break;
        case "drop":
          i = 0, r.value = !1, u && (a.value = C, (S = c.onDrop) == null || S.call(c, C, m));
          break;
      }
    };
    A(e, "dragenter", (m) => p(m, "enter")), A(e, "dragover", (m) => p(m, "over")), A(e, "dragleave", (m) => p(m, "leave")), A(e, "drop", (m) => p(m, "drop"));
  }
  return {
    files: a,
    isOverDropZone: r
  };
}
function ee(e, t, n = {}) {
  const { window: o = D, ...r } = n;
  let a;
  const i = R(() => o && "ResizeObserver" in o), u = () => {
    a && (a.disconnect(), a = void 0);
  }, c = _(() => {
    const s = g(e);
    return Array.isArray(s) ? s.map((v) => O(v)) : [O(s)];
  }), f = x(
    c,
    (s) => {
      if (u(), i.value && o) {
        a = new ResizeObserver(t);
        for (const v of s)
          v && a.observe(v, r);
      }
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    u(), f();
  };
  return I(l), {
    isSupported: i,
    stop: l
  };
}
function lt(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: o = !0,
    windowScroll: r = !0,
    immediate: a = !0,
    updateTiming: i = "sync"
  } = t, u = b(0), c = b(0), f = b(0), l = b(0), s = b(0), v = b(0), d = b(0), p = b(0);
  function m() {
    const y = O(e);
    if (!y) {
      n && (u.value = 0, c.value = 0, f.value = 0, l.value = 0, s.value = 0, v.value = 0, d.value = 0, p.value = 0);
      return;
    }
    const w = y.getBoundingClientRect();
    u.value = w.height, c.value = w.bottom, f.value = w.left, l.value = w.right, s.value = w.top, v.value = w.width, d.value = w.x, p.value = w.y;
  }
  function h() {
    i === "sync" ? m() : i === "next-frame" && requestAnimationFrame(() => m());
  }
  return ee(e, h), x(() => O(e), (y) => !y && h()), Ve(e, h, {
    attributeFilter: ["style", "class"]
  }), r && A("scroll", h, { capture: !0, passive: !0 }), o && A("resize", h, { passive: !0 }), N(() => {
    a && h();
  }), {
    height: u,
    bottom: c,
    left: f,
    right: l,
    top: s,
    width: v,
    x: d,
    y: p,
    update: h
  };
}
function ze(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: o = D, box: r = "content-box" } = n, a = _(() => {
    var s, v;
    return (v = (s = O(e)) == null ? void 0 : s.namespaceURI) == null ? void 0 : v.includes("svg");
  }), i = b(t.width), u = b(t.height), { stop: c } = ee(
    e,
    ([s]) => {
      const v = r === "border-box" ? s.borderBoxSize : r === "content-box" ? s.contentBoxSize : s.devicePixelContentBoxSize;
      if (o && a.value) {
        const d = O(e);
        if (d) {
          const p = d.getBoundingClientRect();
          i.value = p.width, u.value = p.height;
        }
      } else if (v) {
        const d = Array.isArray(v) ? v : [v];
        i.value = d.reduce((p, { inlineSize: m }) => p + m, 0), u.value = d.reduce((p, { blockSize: m }) => p + m, 0);
      } else
        i.value = s.contentRect.width, u.value = s.contentRect.height;
    },
    n
  );
  N(() => {
    const s = O(e);
    s && (i.value = "offsetWidth" in s ? s.offsetWidth : t.width, u.value = "offsetHeight" in s ? s.offsetHeight : t.height);
  });
  const f = x(
    () => O(e),
    (s) => {
      i.value = s ? t.width : 0, u.value = s ? t.height : 0;
    }
  );
  function l() {
    c(), f();
  }
  return {
    width: i,
    height: u,
    stop: l
  };
}
function ct(e, t, n = {}) {
  const {
    root: o,
    rootMargin: r = "0px",
    threshold: a = 0,
    window: i = D,
    immediate: u = !0
  } = n, c = R(() => i && "IntersectionObserver" in i), f = _(() => {
    const p = g(e);
    return (Array.isArray(p) ? p : [p]).map(O).filter(K);
  });
  let l = E;
  const s = b(u), v = c.value ? x(
    () => [f.value, O(o), s.value],
    ([p, m]) => {
      if (l(), !s.value || !p.length)
        return;
      const h = new IntersectionObserver(
        t,
        {
          root: O(m),
          rootMargin: r,
          threshold: a
        }
      );
      p.forEach((y) => y && h.observe(y)), l = () => {
        h.disconnect(), l = E;
      };
    },
    { immediate: u, flush: "post" }
  ) : E, d = () => {
    l(), v(), s.value = !1;
  };
  return I(d), {
    isSupported: c,
    isActive: s,
    pause() {
      l(), s.value = !1;
    },
    resume() {
      s.value = !0;
    },
    stop: d
  };
}
function W(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function je(e = {}) {
  const {
    controls: t = !1,
    interval: n = "requestAnimationFrame"
  } = e, o = b(/* @__PURE__ */ new Date()), r = () => o.value = /* @__PURE__ */ new Date(), a = n === "requestAnimationFrame" ? $e(r, { immediate: !0 }) : Re(r, n, { immediate: !0 });
  return t ? {
    now: o,
    ...a
  } : o;
}
function te(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : te(n);
  }
}
function Be(e) {
  const t = e || window.event, n = t.target;
  return te(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const P = /* @__PURE__ */ new WeakMap();
function ft(e, t = !1) {
  const n = b(t);
  let o = null, r = "";
  x(Fe(e), (u) => {
    const c = W(g(u));
    if (c) {
      const f = c;
      if (P.get(f) || P.set(f, f.style.overflow), f.style.overflow !== "hidden" && (r = f.style.overflow), f.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return f.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const a = () => {
    const u = W(g(e));
    !u || n.value || (V && (o = A(
      u,
      "touchmove",
      (c) => {
        Be(c);
      },
      { passive: !1 }
    )), u.style.overflow = "hidden", n.value = !0);
  }, i = () => {
    const u = W(g(e));
    !u || !n.value || (V && (o == null || o()), u.style.overflow = r, P.delete(u), n.value = !1);
  };
  return I(i), _({
    get() {
      return n.value;
    },
    set(u) {
      u ? a() : i();
    }
  });
}
const He = [
  { max: 6e4, value: 1e3, name: "second" },
  { max: 276e4, value: 6e4, name: "minute" },
  { max: 72e6, value: 36e5, name: "hour" },
  { max: 5184e5, value: 864e5, name: "day" },
  { max: 24192e5, value: 6048e5, name: "week" },
  { max: 28512e6, value: 2592e6, name: "month" },
  { max: Number.POSITIVE_INFINITY, value: 31536e6, name: "year" }
], Qe = {
  justNow: "just now",
  past: (e) => e.match(/\d/) ? `${e} ago` : e,
  future: (e) => e.match(/\d/) ? `in ${e}` : e,
  month: (e, t) => e === 1 ? t ? "last month" : "next month" : `${e} month${e > 1 ? "s" : ""}`,
  year: (e, t) => e === 1 ? t ? "last year" : "next year" : `${e} year${e > 1 ? "s" : ""}`,
  day: (e, t) => e === 1 ? t ? "yesterday" : "tomorrow" : `${e} day${e > 1 ? "s" : ""}`,
  week: (e, t) => e === 1 ? t ? "last week" : "next week" : `${e} week${e > 1 ? "s" : ""}`,
  hour: (e) => `${e} hour${e > 1 ? "s" : ""}`,
  minute: (e) => `${e} minute${e > 1 ? "s" : ""}`,
  second: (e) => `${e} second${e > 1 ? "s" : ""}`,
  invalid: ""
};
function qe(e) {
  return e.toISOString().slice(0, 10);
}
function dt(e, t = {}) {
  const {
    controls: n = !1,
    updateInterval: o = 3e4
  } = t, { now: r, ...a } = je({ interval: o, controls: !0 }), i = _(() => Ue(new Date(g(e)), t, g(r)));
  return n ? {
    timeAgo: i,
    ...a
  } : i;
}
function Ue(e, t = {}, n = Date.now()) {
  var o;
  const {
    max: r,
    messages: a = Qe,
    fullDateFormatter: i = qe,
    units: u = He,
    showSecond: c = !1,
    rounding: f = "round"
  } = t, l = typeof f == "number" ? (h) => +h.toFixed(f) : Math[f], s = +n - +e, v = Math.abs(s);
  function d(h, y) {
    return l(Math.abs(h) / y.value);
  }
  function p(h, y) {
    const w = d(h, y), T = h > 0, S = m(y.name, w, T);
    return m(T ? "past" : "future", S, T);
  }
  function m(h, y, w) {
    const T = a[h];
    return typeof T == "function" ? T(y, w) : T.replace("{0}", y.toString());
  }
  if (v < 6e4 && !c)
    return a.justNow;
  if (typeof r == "number" && v > r)
    return i(new Date(e));
  if (typeof r == "string") {
    const h = (o = u.find((y) => y.name === r)) == null ? void 0 : o.max;
    if (h && v > h)
      return i(new Date(e));
  }
  for (const [h, y] of u.entries()) {
    if (d(s, y) <= 0 && u[h - 1])
      return p(s, u[h - 1]);
    if (v < y.max)
      return p(s, y);
  }
  return a.invalid;
}
const Ge = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
}, vt = /* @__PURE__ */ Object.assign({}, { linear: Z }, Ge);
function Ye([e, t, n, o]) {
  const r = (l, s) => 1 - 3 * s + 3 * l, a = (l, s) => 3 * s - 6 * l, i = (l) => 3 * l, u = (l, s, v) => ((r(s, v) * l + a(s, v)) * l + i(s)) * l, c = (l, s, v) => 3 * r(s, v) * l * l + 2 * a(s, v) * l + i(s), f = (l) => {
    let s = l;
    for (let v = 0; v < 4; ++v) {
      const d = c(s, e, n);
      if (d === 0)
        return s;
      const p = u(s, e, n) - l;
      s -= p / d;
    }
    return s;
  };
  return (l) => e === t && n === o ? l : u(f(l), t, o);
}
function q(e, t, n) {
  return e + n * (t - e);
}
function M(e) {
  return (typeof e == "number" ? [e] : e) || [];
}
function Xe(e, t, n, o = {}) {
  var r, a;
  const i = g(t), u = g(n), c = M(i), f = M(u), l = (r = g(o.duration)) != null ? r : 1e3, s = Date.now(), v = Date.now() + l, d = typeof o.transition == "function" ? o.transition : (a = g(o.transition)) != null ? a : Z, p = typeof d == "function" ? d : Ye(d);
  return new Promise((m) => {
    e.value = i;
    const h = () => {
      var y;
      if ((y = o.abort) != null && y.call(o)) {
        m();
        return;
      }
      const w = Date.now(), T = p((w - s) / l), S = M(e.value).map((C, k) => q(c[k], f[k], T));
      Array.isArray(e.value) ? e.value = S.map((C, k) => {
        var z, j;
        return q((z = c[k]) != null ? z : 0, (j = f[k]) != null ? j : 0, T);
      }) : typeof e.value == "number" && (e.value = S[0]), w < v ? requestAnimationFrame(h) : (e.value = u, m());
    };
    h();
  });
}
function mt(e, t = {}) {
  let n = 0;
  const o = () => {
    const a = g(e);
    return typeof a == "number" ? a : a.map(g);
  }, r = b(o());
  return x(o, async (a) => {
    var i, u;
    if (g(t.disabled))
      return;
    const c = ++n;
    if (t.delay && await Ee(g(t.delay)), c !== n)
      return;
    const f = Array.isArray(a) ? a.map(g) : g(a);
    (i = t.onStarted) == null || i.call(t), await Xe(r, r.value, f, {
      ...t,
      abort: () => {
        var l;
        return c !== n || ((l = t.abort) == null ? void 0 : l.call(t));
      }
    }), (u = t.onFinished) == null || u.call(t);
  }, { deep: !0 }), x(() => g(t.disabled), (a) => {
    a && (n++, r.value = o());
  }), I(() => {
    n++;
  }), _(() => g(t.disabled) ? o() : r.value);
}
function pt(e, t) {
  const { containerStyle: n, wrapperProps: o, scrollTo: r, calculateRange: a, currentList: i, containerRef: u } = "itemHeight" in t ? Je(t, e) : Ze(t, e);
  return {
    list: i,
    scrollTo: r,
    containerProps: {
      ref: u,
      onScroll: () => {
        a();
      },
      style: n
    },
    wrapperProps: o
  };
}
function ne(e) {
  const t = b(null), n = ze(t), o = b([]), r = L(e);
  return { state: b({ start: 0, end: 10 }), source: r, currentList: o, size: n, containerRef: t };
}
function oe(e, t, n) {
  return (o) => {
    if (typeof n == "number")
      return Math.ceil(o / n);
    const { start: r = 0 } = e.value;
    let a = 0, i = 0;
    for (let u = r; u < t.value.length; u++) {
      const c = n(u);
      if (a += c, i = u, a > o)
        break;
    }
    return i - r;
  };
}
function re(e, t) {
  return (n) => {
    if (typeof t == "number")
      return Math.floor(n / t) + 1;
    let o = 0, r = 0;
    for (let a = 0; a < e.value.length; a++) {
      const i = t(a);
      if (o += i, o >= n) {
        r = a;
        break;
      }
    }
    return r + 1;
  };
}
function ae(e, t, n, o, { containerRef: r, state: a, currentList: i, source: u }) {
  return () => {
    const c = r.value;
    if (c) {
      const f = n(e === "vertical" ? c.scrollTop : c.scrollLeft), l = o(e === "vertical" ? c.clientHeight : c.clientWidth), s = f - t, v = f + l + t;
      a.value = {
        start: s < 0 ? 0 : s,
        end: v > u.value.length ? u.value.length : v
      }, i.value = u.value.slice(a.value.start, a.value.end).map((d, p) => ({
        data: d,
        index: p + a.value.start
      }));
    }
  };
}
function ue(e, t) {
  return (n) => typeof e == "number" ? n * e : t.value.slice(0, n).reduce((r, a, i) => r + e(i), 0);
}
function ie(e, t, n, o) {
  x([e.width, e.height, t, n], () => {
    o();
  });
}
function se(e, t) {
  return _(() => typeof e == "number" ? t.value.length * e : t.value.reduce((n, o, r) => n + e(r), 0));
}
const Ke = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function le(e, t, n, o) {
  return (r) => {
    o.value && (o.value[Ke[e]] = n(r), t());
  };
}
function Ze(e, t) {
  const n = ne(t), { state: o, source: r, currentList: a, size: i, containerRef: u } = n, c = { overflowX: "auto" }, { itemWidth: f, overscan: l = 5 } = e, s = oe(o, r, f), v = re(r, f), d = ae("horizontal", l, v, s, n), p = ue(f, r), m = _(() => p(o.value.start)), h = se(f, r);
  ie(i, t, u, d);
  const y = le("horizontal", d, p, u), w = _(() => ({
    style: {
      height: "100%",
      width: `${h.value - m.value}px`,
      marginLeft: `${m.value}px`,
      display: "flex"
    }
  }));
  return {
    scrollTo: y,
    calculateRange: d,
    wrapperProps: w,
    containerStyle: c,
    currentList: a,
    containerRef: u
  };
}
function Je(e, t) {
  const n = ne(t), { state: o, source: r, currentList: a, size: i, containerRef: u } = n, c = { overflowY: "auto" }, { itemHeight: f, overscan: l = 5 } = e, s = oe(o, r, f), v = re(r, f), d = ae("vertical", l, v, s, n), p = ue(f, r), m = _(() => p(o.value.start)), h = se(f, r);
  ie(i, t, u, d);
  const y = le("vertical", d, p, u), w = _(() => ({
    style: {
      width: "100%",
      height: `${h.value - m.value}px`,
      marginTop: `${m.value}px`
    }
  }));
  return {
    calculateRange: d,
    scrollTo: y,
    containerStyle: c,
    wrapperProps: w,
    currentList: a,
    containerRef: u
  };
}
function ht(e = {}) {
  const {
    window: t = D,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: r = !0,
    includeScrollbar: a = !0,
    type: i = "inner"
  } = e, u = b(n), c = b(o), f = () => {
    t && (i === "outer" ? (u.value = t.outerWidth, c.value = t.outerHeight) : a ? (u.value = t.innerWidth, c.value = t.innerHeight) : (u.value = t.document.documentElement.clientWidth, c.value = t.document.documentElement.clientHeight));
  };
  if (f(), N(f), A("resize", f, { passive: !0 }), r) {
    const l = Ne("(orientation: portrait)");
    x(l, () => f());
  }
  return { width: u, height: c };
}
export {
  vt as T,
  lt as a,
  ot as b,
  A as c,
  it as d,
  ct as e,
  rt as f,
  ut as g,
  ft as h,
  mt as i,
  ht as j,
  dt as k,
  st as l,
  at as o,
  pt as u,
  nt as w
};
//# sourceMappingURL=vueuse-c06f1965.js.map
